import { render, staticRenderFns } from "./work_field_edit.vue?vue&type=template&id=fce985fe&scoped=true"
import script from "./work_field_edit.vue?vue&type=script&lang=js"
export * from "./work_field_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fce985fe",
  null
  
)

export default component.exports